import { AppColors } from "@common/types/AppColorsType";
import { ThemePalette } from "@common/types/ThemePalleteType.ts";

export const themePaletteSelDir: ThemePalette = {
    background: {
        DEFAULT: '#12151f',
        PAPER: '#1a2033',
        SECONDARY_BG_COLOR: 'rgb(80,16,129)'
    },
    font: {
        DEFAULT: '#ffffff',
        DEFAULT_DIMMED: 'rgba(255,255,255,0.5)'
    },
    mode: 'dark'
};

export const themePaletteClientsDir: ThemePalette = {
    background: {
        DEFAULT: '#12151f',
        PAPER: '#1a2033',
        SECONDARY_BG_COLOR: 'rgb(80,16,129)'
    },
    font: {
        DEFAULT: '#ffffff',
        DEFAULT_DIMMED: 'rgba(255,255,255,0.5)'
    },
    mode: 'dark'
};

export const themePaletteCompass: ThemePalette = {
    background: {
        DEFAULT: '#F4F6F8',
        PAPER: 'rgba(243,243,243,0.95)',
        SECONDARY_BG_COLOR: '#7383dd'
    },
    font: {
        DEFAULT: '#37474f',
        DEFAULT_DIMMED: 'rgba(55,71,79,0.5)'
    },
    mode: 'light'
};

export const themePalettePickleLeads: ThemePalette = {
    background: {
        DEFAULT: '#12151f',
        PAPER: '#1a2033',
        SECONDARY_BG_COLOR: 'rgb(80,16,129)'
    },
    font: {
        DEFAULT: '#ffffff',
        DEFAULT_DIMMED: 'rgba(255,255,255,0.5)'
    },
    mode: 'dark'
};

export const sellersDirectColors: AppColors = {
    callToActionColor: 'linear-gradient(180deg, #FFD056 0%, #FF800B 100%)',
    callToActionTextColor: "#000000",
    navBarColor: 'linear-gradient(270deg, #8C01F9 0%, #0042ED 98.99%)',
    navBarTextColor: "#ffffff",
    whiteFontColor: themePaletteSelDir.font.DEFAULT,
    blueLinkColor: 'rgb(1, 177, 244)',
    blueBtnColor: '#0143ED',
    cancelRed: '#FF8383',
    successGreen: '#12974B',
    dangerBtnColor: 'linear-gradient(180deg, #FF0000 0%, #9A0000 100%)',
    dangerBtnTextColor: "#ffffff",
};

export const clientsDirectColors: AppColors = {
    callToActionColor: 'linear-gradient(180deg, #FFD056 0%, #FF800B 100%)',
    callToActionTextColor: "#000000",
    navBarColor: 'linear-gradient(270deg, #8C01F9 0%, #0042ED 98.99%)',
    navBarTextColor: "#ffffff",
    whiteFontColor: themePaletteClientsDir.font.DEFAULT,
    blueLinkColor: 'rgb(1, 177, 244)',
    blueBtnColor: '#0143ED',
    cancelRed: '#FF8383',
    successGreen: '#12974B',
    dangerBtnColor: 'linear-gradient(180deg, #FF0000 0%, #9A0000 100%)',
    dangerBtnTextColor: "#ffffff",
};

export const compassColors: AppColors = {
    callToActionColor: 'linear-gradient(180deg, #3f51b5 0%, #3f51b5 100%)',
    callToActionTextColor: "#ffffff",
    navBarColor: 'linear-gradient(270deg, #3f51b5 0%, #3f51b5 98.99%)',
    navBarTextColor: "#ffffff",
    whiteFontColor: "#ffffff",
    blueLinkColor: 'rgb(1, 177, 244)',
    cancelRed: '#FF8383',
    blueBtnColor: '#0143ED',
    successGreen: '#12974B',
    dangerBtnColor: 'linear-gradient(180deg, #df4b4b 0%, #df4b4b 100%)',
    dangerBtnTextColor: "#ffffff",
};

export const pickleLeadsColors: AppColors = {
    callToActionColor: 'linear-gradient(180deg, #FFD056 0%, #FF800B 100%)',
    callToActionTextColor: "#000000",
    navBarColor: 'linear-gradient(270deg, #8C01F9 0%, #0042ED 98.99%)',
    navBarTextColor: "#ffffff",
    whiteFontColor: themePaletteSelDir.font.DEFAULT,
    blueLinkColor: 'rgb(1, 177, 244)',
    blueBtnColor: '#0143ED',
    cancelRed: '#FF8383',
    successGreen: '#12974B',
    dangerBtnColor: 'linear-gradient(180deg, #FF0000 0%, #9A0000 100%)',
    dangerBtnTextColor: "#ffffff",
};